/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The cloud provider of the credential.
 */
export const ExternalCredentialSummaryProvider = {
  AwsIam: "aws_iam",
  GcpIam: "gcp_iam",
} as const;
/**
 * The cloud provider of the credential.
 */
export type ExternalCredentialSummaryProvider = ClosedEnum<
  typeof ExternalCredentialSummaryProvider
>;

/**
 * Provider-independent summary of an external credential.
 */
export type ExternalCredentialSummary = {
  /**
   * When the credential was created.
   */
  createdAt: Date;
  /**
   * The ID of the external credential.
   */
  id: string;
  /**
   * A human-readable name for the credential.
   */
  name: string;
  /**
   * The organization that owns the credential.
   */
  organizationId: string;
  /**
   * The cloud provider of the credential.
   */
  provider: ExternalCredentialSummaryProvider;
  /**
   * When the credential was last updated.
   */
  updatedAt: Date;
};

/** @internal */
export const ExternalCredentialSummaryProvider$inboundSchema: z.ZodMiniEnum<
  typeof ExternalCredentialSummaryProvider
> = z.enum(ExternalCredentialSummaryProvider);

/** @internal */
export const ExternalCredentialSummary$inboundSchema: z.ZodMiniType<
  ExternalCredentialSummary,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    name: z.string(),
    organization_id: z.string(),
    provider: ExternalCredentialSummaryProvider$inboundSchema,
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "organization_id": "organizationId",
      "updated_at": "updatedAt",
    });
  }),
);

export function externalCredentialSummaryFromJSON(
  jsonString: string,
): SafeParseResult<ExternalCredentialSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalCredentialSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalCredentialSummary' from JSON`,
  );
}
